<template>
  <ButtonSnsSmall class="btn-sns--instagram" @click-sns-button="onClick" />
</template>

<script>
import ButtonSnsSmall from '../../../atoms/buttons/ButtonSnsSmall.vue'
export default {
  components: { ButtonSnsSmall },
  methods: {
    onClick() {
      this.$emit('click-instagram-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-sns--instagram {
  @include bg-settings(
    '../../../../../../images/buttons/instagram-with-background.svg',
    $gray-1,
    100%,
    100%
  );
}
</style>
